import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { NAME, CLEAR_AUTHENTICATION_ERROR } from './constants';
import {
    REQUEST_LOGIN,
    SUCCESS_LOGIN,
    SUCCESS_DARTY_LOGIN,
    FAILURE_LOGIN,
    RESET_LOGIN_FORM
} from './login/constants';
import {
    REFRESH_TOKEN_REQUEST,
    REFRESH_TOKEN_SUCCESS,
    REFRESH_TOKEN_FAILURE
} from './refresh/constants';
import {
    SUCCESS_PASSWORD_RESET_COMMIT,
    SUCCESS_PASSWORD_RESET_INIT
} from './resetpassword/constants';
import { REQUEST_LOGOUT, SUCCESS_LOGOUT, FAILURE_LOGOUT } from './logout/constants';
import {
    REQUEST_REGISTER,
    SUCCESS_REGISTER,
    SUCCESS_DARTY_REGISTER,
    FAILURE_REGISTER
} from './register/constants';

import resetpassword from './resetpassword';

/*
 * State shape
 {
    token: '',
    fetching: false,
    isAuthenticated: false,
    limited: false,
    provider: '',
    error: ''
 }
*/

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_LOGOUT:
        case REQUEST_LOGIN:
        case REQUEST_REGISTER:
        case REFRESH_TOKEN_REQUEST:
            return true;
        case SUCCESS_REGISTER:
        case SUCCESS_DARTY_REGISTER:
        case SUCCESS_LOGIN:
        case SUCCESS_DARTY_LOGIN:
        case SUCCESS_LOGOUT:
        case REFRESH_TOKEN_SUCCESS:
        case FAILURE_REGISTER:
        case FAILURE_LOGIN:
        case FAILURE_LOGOUT:
        case REFRESH_TOKEN_FAILURE:
        case RESET_LOGIN_FORM:
            return false;
        default:
            return state;
    }
};

// RESET_LOGIN_FORM ne doit PAS effacer le token : il est dispatché au démontage du
// formulaire de login, qui survient juste après une connexion réussie (redirection)
const token = (state = '', action) => {
    switch (action.type) {
        case SUCCESS_REGISTER:
        case SUCCESS_LOGIN:
        case REFRESH_TOKEN_SUCCESS:
            return action.response.payload.token;
        case SUCCESS_LOGOUT:
        case FAILURE_REGISTER:
        case FAILURE_LOGIN:
        case FAILURE_LOGOUT:
        case REFRESH_TOKEN_FAILURE:
            return '';
        default:
            return state;
    }
};

// Origine de l'authentification (PROVIDER_FNAC | PROVIDER_DARTY), renvoyée par
// /auth/login en écho du body ; conservée au refresh du JWT (la réponse de
// /auth/refresh ne porte pas de provider)
const provider = (state = '', action) => {
    switch (action.type) {
        case SUCCESS_LOGIN:
            return action.response.payload.provider || '';
        case SUCCESS_LOGOUT:
        case FAILURE_REGISTER:
        case FAILURE_LOGIN:
        case FAILURE_LOGOUT:
        case REFRESH_TOKEN_FAILURE:
            return '';
        default:
            return state;
    }
};

// Accès limité (abonnement expiré depuis moins d'un an) : le back recalcule le flag
// à chaque login ET à chaque refresh du JWT (AuthDto.limited).
// Comme token : RESET_LOGIN_FORM ne doit PAS l'effacer.
const limited = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_REGISTER:
        case SUCCESS_LOGIN:
        case REFRESH_TOKEN_SUCCESS:
            return !!action.response.payload.limited;
        case SUCCESS_LOGOUT:
        case FAILURE_REGISTER:
        case FAILURE_LOGIN:
        case FAILURE_LOGOUT:
        case REFRESH_TOKEN_FAILURE:
            return false;
        default:
            return state;
    }
};

const isAuthenticated = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_REGISTER:
        case SUCCESS_LOGIN:
        case REFRESH_TOKEN_SUCCESS:
            return true;
        case SUCCESS_PASSWORD_RESET_COMMIT:
        case SUCCESS_PASSWORD_RESET_INIT:
        case SUCCESS_LOGOUT:
        case FAILURE_REGISTER:
        case FAILURE_LOGIN:
        case FAILURE_LOGOUT:
        case REFRESH_TOKEN_FAILURE:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_REGISTER:
        case FAILURE_LOGIN:
        case FAILURE_LOGOUT:
        case REFRESH_TOKEN_FAILURE:
            return action.response.message;
        case SUCCESS_LOGIN:
        case SUCCESS_LOGOUT:
        case SUCCESS_REGISTER:
        case REFRESH_TOKEN_SUCCESS:
        case REQUEST_LOGIN:
        case REQUEST_LOGOUT:
        case REQUEST_REGISTER:
        case REFRESH_TOKEN_REQUEST:
        case RESET_LOGIN_FORM:
        case CLEAR_AUTHENTICATION_ERROR:
            return '';
        default:
            return state;
    }
};

// Persist only token
const authenticationPersistConfig = {
    key: NAME,
    storage: storage,
    whitelist: ['token', 'isAuthenticated', 'provider', 'limited']
};

const reducer = combineReducers({
    fetching,
    isAuthenticated,
    limited,
    token,
    provider,
    error,
    [resetpassword.constants.NAME]: resetpassword.reducer
});

export default persistReducer(authenticationPersistConfig, reducer);



// WEBPACK FOOTER //
// ./src/services/authentication/reducer.js